// extracted by mini-css-extract-plugin
export default {"register":"Register_register__H6uKZ","register_form":"Register_register_form__qoLL1","conta":"Register_conta__lEHkQ"};